import { render, staticRenderFns } from "./price-tracking-v2.tab.vue?vue&type=template&id=36185e0b&scoped=true"
import script from "./price-tracking-v2.tab.vue?vue&type=script&lang=js"
export * from "./price-tracking-v2.tab.vue?vue&type=script&lang=js"
import style0 from "./price-tracking-v2.tab.vue?vue&type=style&index=0&id=36185e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36185e0b",
  null
  
)

export default component.exports